// extracted by mini-css-extract-plugin
export default {"container":"BulkOrder_Item_container__dWwlD","actions":"BulkOrder_Item_actions__SPsFP","toggle":"BulkOrder_Item_toggle__DEI9H"};